<template>
  <b-modal
    id="evaluation-form-container"
    title="Realizar evaluación"
    v-model="showModal"
    hide-footer
    centered
  >
    <div class="w-100">
      <b-form-rating
        no-border
        id="evaluation-form"
        v-model="evaluation"
        stars="5"
        inline
        variant="warning"
        size="lg"
      />
    </div>
    <vs-divider />
    <div class="d-flex justify-end">
      <vs-button
        class="ml-3"
        v-on:click="saveEvaluationForm"
        color="primary"
        type="border"
      >
        Evaluar
        <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
      </vs-button>
      <vs-button
        class="ml-3"
        v-on:click="closeModal"
        color="danger"
        type="border"
      >
        Cancelar
        <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
      </vs-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { ioEDEvaluationsAdd, ioEDFilesGet } from '@/febos/servicios/api/repositories.api';

export default {
  name: 'EvaluationForm',
  data() {
    return {
      evaluation: 0,
      loading: false
    };
  },
  mounted() {
    this.evaluation = this.getSelectedElement.evaluation;
  },
  methods: {
    ...mapActions('DocManagement', [
      'setSelectedElement'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async saveEvaluationForm() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      await ioEDEvaluationsAdd({
        repositoryId: this.getSelectedElement.repositoryId,
        fileId: this.getSelectedElement.id,
        evaluation: this.evaluation
      });
      const response = await ioEDFilesGet({
        repositoryId: this.getSelectedElement.repositoryId,
        fileId: this.getSelectedElement.id
      });
      const newElement = response.data;
      await this.setSelectedElement({
        id: newElement.archivo.archivoId,
        name: newElement.archivo.nombre,
        creationDate: newElement.archivo.fechaCreacion,
        publicationDate: newElement.archivo.fechaPublicacion,
        parentFolder: this.getSelectedElement.id,
        ownerId: newElement.archivo.propietario.id,
        owner: newElement.archivo.propietario.alias,
        size: newElement.archivo.pesoArchivo,
        type: 'file',
        repositoryId: this.getSelectedElement.repositoryId,
        downloadURL: `${newElement.archivo.urlDescarga}?t=${this.currentUser.token}&e=${this.companyId}`,
        publicLink: newElement.archivo.esPublico === 'S' ? newElement.archivo.urlDescarga : undefined,
        isPublic: newElement.archivo.esPublico === 'S',
        internalVersion: newElement.archivo.versionInterna,
        externalVersion: newElement.archivo.versionExterna,
        language: newElement.archivo.idioma,
        tags: newElement.tags,
        keywords: newElement.keywords,
        mimeType: newElement.archivo.mime,
        evaluation: newElement.archivo.evaluacion || 0,
        totalEvaluations: newElement.archivo.totalEvaluaciones || 0,
        validityState: newElement.archivo.estadoVigencia,
        approvalState: newElement.archivo.estadoAprobacion,
        publicationState: newElement.archivo.estadoPublicacion,
        expirationDate: newElement.archivo.fechaVencimiento,
        expirationType: newElement.archivo.tipoExpiracion,
        loggedUserPermissions: newElement.misPermisos
      });
      this.$bvToast.toast(
        'Su evaluación ha sido registrada!',
        {
          title: this.title,
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 15000
        }
      );
      this.loading = false;
      this.closeModal();
    }
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedElement'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'evaluationFormED';
      },
      set() {
        this.closeModal();
      }
    }
  }
};
</script>
